// Whether the quick tour is up (#4234, found recording the Home Screen
// tutorial): AppLayout decides on a first sign-in whether to open the
// 11-step tour, and Astra Today's notification ask (PushAsk) must not open
// under it, two modal dialogs stacked. PushAsk is mounted beside the routes,
// not inside AppLayout, so the state is shared here.
//
//   'none'    - no tour open, nothing pending. The default, so a page outside
//               AppLayout (which never opens the tour) asks as before.
//   'pending' - AppLayout is deciding (its profile read is in flight).
//   'open'    - the tour is on screen.
import { useSyncExternalStore } from 'react';

let state = 'none';
const listeners = new Set();

export function getQuickTourState() { return state; }

export function setQuickTourState(next) {
    if (next === state || !['none', 'pending', 'open'].includes(next)) return;
    state = next;
    listeners.forEach((fn) => fn());
}

function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

/** The tour's state; re-renders when it changes. */
export function useQuickTourState() {
    return useSyncExternalStore(subscribe, getQuickTourState, getQuickTourState);
}
